import { IRegulation } from './amendment.contract';

export interface ICalendarSurvey {
    ClassNumber: string;
    CertificateName: string;
    CertificateIssueDate: string;
    CertificateExpiryDate: string;
    SurveyDescription: string;
    SurveyDueDate: string;
    Regulations: IRegulation[];
    RegulationCount: number;
}

export enum CalendarReportType {
    DueDate = "DueDate",
    Vessel = "Vessel",
    Survey = "Survey"
}